// extracted by mini-css-extract-plugin
export default {"UnifiedHeader":"index_UnifiedHeader__1hFDy"};